<main>
  <div class="container p-5" *transloco="let t">

    @if (isAnythingLoading()) {
      <multisite-loader-globe-animation-detail [width]="100" [height]="100">
      </multisite-loader-globe-animation-detail>
    }

    @for (course of coursesAsContent; track course) {
      <div class="card promo-card">
        <a (click)="navigateTo(course.slug, $event)">
          <div class="row">
            <div class="col-md-4">
              <a (click)="navigateTo(course.slug, $event)">
                @if (course.images | imageForRole:'thumbnail':true; as cover) {
                  <img class="img-fluid rounded-start w-100"
                    [src]="cover | imageUrl:thumbnailTransformations"
                    [alt]="cover.alt_text">
                }
              </a>
            </div>
            <div class="col-md-8">
              <div class="card-body p-0">
                <a (click)="navigateTo(course.slug, $event)">
                  <h5 class="card-title mt-4 mt-md-0">{{course.title}}</h5>
                </a>
                <p class="card-text text-muted mt-2">{{course.description}}</p>
                <div class="badges mt-2">
                  @for (tag of course.tags; track tag) {
                    <span class="m-1" [ngClass]=" [tag.type == 'topic' ? 'badge-info' : 'badge-primary', 'badge badge-pill']">
                      @if ($any(tag).icon_type === 'fa' && $any(tag).icon_identifier) {
                        <i [class]="'mr-1 ' + $any(tag).icon_identifier + ($any(tag).icon_identifier.includes(' ') ? '' :'fa-solid')"></i>
                      }
                      @if ($any(tag).icon_type === 'emoji' && $any(tag).icon_identifier) {
                        <span [class]="'mr-1'">{{$any(tag).icon_identifier}}</span>
                      }
                      @if ($any(tag).icon_type === 'cloudinary_flag' && $any(tag).icon_identifier) {
                        <img [class]="'mr-1'" [src]="getFlagUrlFromHash($any(tag).icon_identifier, 'w_250,c_fill/')">
                      }
                      @if ($any(tag).icon_type === 'cloudinary_icon' && $any(tag).icon_identifier) {
                        <img [class]="'mr-1'" [src]="getFlagUrlFromHash($any(tag).icon_identifier, 'w_250,c_fill/')">
                      }
                      @if ($any(tag).img_url && !$any(tag).icon_identifier) {
                        <img [class]="'mr-1'" [src]="$any(tag).img_url">
                      }
                      {{tag.name}}
                      <!-- <span class="badge badge-pill badge-more" (click)="action()">
                      <i class="fa-solid fa-angle-right"></i>
                    </span> -->
                  </span>
                }
              </div>
              <div class="col-12 my-2">
                @if (course.rating) {
                  <div class="col-12 my-2">
                    <span style="margin:15px 0;"> {{roundRating(course.rating)}} </span>
                    <rating ngClass="text-warning" [(ngModel)]="course.rating" [max]="5" [readonly]="true"></rating>
                  </div>
                }
              </div>
              <p class="card-text">
                <small class="text-muted">{{t('common.updated')}} {{course.date | date : 'longDate'}}</small>
              </p>
              <div class="mt-4">
                <button class="btn btn-primary d-block d-sm-inline w-sm-100"
                [routerLink]="['./'+course.slug]">{{t(course.cta_translationKey)}}</button>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  }



  @if (!isAnythingLoading() && !coursesAsContent?.length) {
    <p>{{t('common.no_results')}}</p>
  }


</div>
</main>